import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Quote from '../../images/testimonial/quote-2.svg';

const testimonials = [
    {
        id: "01",
        Des: "From the first consultation to the final design approval, everything was handled professionally. The team understood our block constraints and delivered a home that feels open, modern, and practical.",
        Title: "Sam Dev",
        Sub: "Home Buyer • Melbourne, VIC",
    },
    {
        id: "02",
        Des: "As first-time home buyers, we were nervous about the process, but communication was clear at every step. The final outcome exceeded our expectations in both design and functionality.",
        Title: "Alex Thomson",
        Sub: "First-Time Home Buyer • Melbourne, VIC",
    },
    {
        id: "03",
        Des: "What impressed us most was the attention to detail. Every suggestion felt well thought out, and nothing felt rushed. The design suits our lifestyle perfectly.",
        Title: "Michael & Sarah Collins",
        Sub: "Custom Home Clients • Brisbane, QLD",
    },
    {
        id: "04",
        Des: "Building at 11 Longview Avenue in Leopold came with its challenges, but the design response was spot on. The layout maximised light and space while still maintaining privacy.",
        Title: "Andrew Wilson",
        Sub: "Home Owner • Leopold VIC 3224",
    },
    {
        id: "05",
        Des: "We wanted a modern home that still felt warm and liveable. The design balanced aesthetics and practicality beautifully, and the process was smooth from start to finish.",
        Title: "Rebecca Hall",
        Sub: "Home Buyer • Geelong, VIC",
    },
    {
        id: "06",
        Des: "The team listened carefully to what we wanted and offered smart solutions we hadn’t even considered. The final design fits our block and lifestyle perfectly.",
        Title: "James Peterson",
        Sub: "Custom Build Client • Torquay, VIC",
    },
    {
        id: "07",
        Des: "We appreciated how transparent and organised everything was. There were no surprises, just clear communication and a design that truly feels like home.",
        Title: "Lauren McCarthy",
        Sub: "Family Home Buyer • Ballarat, VIC",
    },
    {
        id: "08",
        Des: "Designing our home in Leopold was a great experience. The layout flows well, captures natural light, and reflects exactly what we were hoping for in a long-term family home.",
        Title: "Nathan & Olivia Brooks",
        Sub: "Home Owners • Leopold VIC 3224",
    },
];

const Testimonial = (props) => {

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dots: true,
                    arrows: false,
                }
            },
        ]
    };

    return (
        <section className={props.hclass || ""}>
            <Slider {...settings} className="testimonial-slider">
                {testimonials.slice(0, 2).map((testimonial, index) => (
                    <div className="item" key={index}>
                        <div className="content fade_bottom">
                            <div className="icon">
                                <img src={Quote} alt="quote" />
                            </div>
                            <h3>{testimonial.Des}</h3>
                            <h4>{testimonial.Title}</h4>
                            <span>{testimonial.Sub}</span>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default Testimonial;
